import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import type { NbDisplayDataOutput, NbExecuteResultOutput, NbOutput } from './nbformat'
import { joinMultiline, sanitizeHtml, stripAnsi } from './outputUtils'
import './notebookOutputs.css'

const REMARK_PLUGINS = [remarkGfm]

function RichOutput({ data }: { data: (NbDisplayDataOutput | NbExecuteResultOutput)['data'] }) {
  if (data['image/png']) {
    return <img alt="output" src={`data:image/png;base64,${joinMultiline(data['image/png'])}`} className="nb-output-image" />
  }
  if (data['image/jpeg']) {
    return <img alt="output" src={`data:image/jpeg;base64,${joinMultiline(data['image/jpeg'])}`} className="nb-output-image" />
  }
  if (data['image/svg+xml']) {
    return <div className="nb-output-html" dangerouslySetInnerHTML={{ __html: sanitizeHtml(joinMultiline(data['image/svg+xml'])) }} />
  }
  if (data['text/html']) {
    return <div className="nb-output-html overflow-x-auto" dangerouslySetInnerHTML={{ __html: sanitizeHtml(joinMultiline(data['text/html'])) }} />
  }
  if (data['text/markdown']) {
    return (
      <div className="prose prose-sm dark:prose-invert max-w-none">
        <ReactMarkdown remarkPlugins={REMARK_PLUGINS}>{joinMultiline(data['text/markdown'])}</ReactMarkdown>
      </div>
    )
  }
  if (data['text/plain']) {
    return <pre className="nb-output-text">{joinMultiline(data['text/plain'])}</pre>
  }
  return null
}

export function NotebookOutput({ output }: { output: NbOutput }) {
  if (output.output_type === 'stream') {
    const isStderr = output.name === 'stderr'
    return (
      <pre
        className={isStderr ? 'nb-output-text nb-output-stderr' : 'nb-output-text'}
        data-mime-type={isStderr ? 'application/vnd.jupyter.stderr' : undefined}
      >
        {joinMultiline(output.text)}
      </pre>
    )
  }
  if (output.output_type === 'execute_result' || output.output_type === 'display_data') {
    return <RichOutput data={output.data || {}} />
  }
  if (output.output_type === 'error') {
    const traceback = (output.traceback || []).map(stripAnsi).join('\n')
    return <pre className="nb-output-text nb-output-error">{traceback || `${output.ename}: ${output.evalue}`}</pre>
  }
  return null
}
